import { useIntl } from 'react-intl';

import { tierConfig } from 'constants/loyalty.constants';
import { useAccount } from 'queries/accounts/useAccount';
import { useLoyaltyTiers } from 'queries/accounts/useLoyaltyTiers';

interface LoyaltyTranslations {
  cartLabel: string | undefined;
  discountLabel: string | undefined;
  hasDiscount: boolean;
}

const intialState: LoyaltyTranslations = {
  cartLabel: undefined,
  discountLabel: undefined,
  hasDiscount: false,
};

/**
 * Hook to get the loyalty translations based on the current loyalty tier.
 */
export const useLoyaltyTranslations = (): LoyaltyTranslations => {
  const { loyaltyTier } = useAccount();
  const { loyaltyTiers } = useLoyaltyTiers();
  const intl = useIntl();

  if (!loyaltyTiers?.length || !loyaltyTier) {
    return intialState;
  }

  const discount = loyaltyTiers?.find(
    (tier) => tier.id === loyaltyTier,
  )?.discountPercentage;

  const hasDiscount = !!discount;

  if (!discount) {
    return {
      cartLabel: undefined,
      discountLabel: intl.formatMessage({
        id: 'loyalty.tier.checkout.no_discount.label',
      }),
      hasDiscount,
    };
  }

  return {
    cartLabel: intl.formatMessage(
      { id: 'loyalty.tier.cart.discount.label' },
      {
        discount,
        tier: intl.formatMessage({ id: tierConfig[loyaltyTier].intlId }),
      },
    ),
    discountLabel: [
      `${discount}${intl.formatMessage({ id: 'general.percentage.symbol' })}`,
      intl.formatMessage({ id: 'general.discount.label' }).toLowerCase(),
    ].join(' '),
    hasDiscount,
  };
};
